
import { Component, Vue } from 'vue-property-decorator'
import { modifyBindingVersionCode,getCompanyInfoByPartner } from '@/api/company'
@Component({
  name: 'DateTypeDialog'
})
export default class DateTypeDialog extends Vue {
  showDialog = false
  times = 3 // 倒计时时间
  companyShortName = '' // 合作方公司名称简称
  show (companyShortName: string,versionCode:string) {
    this.companyShortName = companyShortName
    this.showDialog = true
    let timeIn = setInterval(() => {
      this.times--
      if (this.times === 0) {
        this.showDialog = false
        clearInterval(timeIn)
        this.$store.commit('SET_CURRENTVERSION', {currentVersionCode:versionCode,partnerCompanyName:companyShortName})
          this.backHomes(versionCode)
      }
    }, 1000)
  }
  backHomes(versionCode:string){
      modifyBindingVersionCode({ versionCode:versionCode }).then(res => {
          getCompanyInfoByPartner({ partnerCompanyId: res.data.partnerCompanyId }).then((data) => {
              let parmas={
                  partnerLogoUrl:data.data.logoUrl, // 合作方Logo
                  partnerCompanyId:data.data.companyId,  // 合作方Id
                  partnerCompanyName:data.data.companyName, // 合作方名称
                  currentVersionCode:versionCode, // 版本号
                  partnerCompanyShortName:data.data.companyShortName, // 合作方简称
              }
              console.log('调用原生updateuserInfo方法')
              console.log(parmas)
              this.$bridge.callHandler('updateUserInfo',parmas,()=>{
                  // 调用原生方法返回首页
                  this.$bridge.callHandler('backHomes')
              })
          })
      })
  }
}
